import { useNavigate } from 'react-router-dom'
import { usePostQuery } from 'hooks'
import { Card, Title } from 'components'
import { NpcAdminForm } from './form'

export const AdminNpcNew = () => {
  const navigate = useNavigate()
  const { post: createNpc } = usePostQuery({ url: '/admin/npcs' })

  const handleSubmit = async (data) => {
    const res = await createNpc(data)
    if (res?.npc?.id) navigate('/admin/npcs')
  }

  return (
    <Card margin="0.5rem">
      <Title level={3} color="link">New NPC</Title>
      <NpcAdminForm onSubmit={handleSubmit} submitLabel="Create NPC" />
    </Card>
  )
}
